var map = {
	"./backgrounds/history_bg_1920.png": 5595,
	"./backgrounds/history_bg_1920.webp": 1944,
	"./backgrounds/history_bg_1922.png": 2173,
	"./backgrounds/history_bg_1922.webp": 2837,
	"./backgrounds/history_bg_1972.png": 8436,
	"./backgrounds/history_bg_1972.webp": 1299,
	"./backgrounds/history_bg_1979.png": 603,
	"./backgrounds/history_bg_1979.webp": 5041,
	"./backgrounds/history_bg_2008.png": 8465,
	"./backgrounds/history_bg_2008.webp": 5434,
	"./backgrounds/history_bg_2012.png": 8759,
	"./backgrounds/history_bg_2012.webp": 4240,
	"./backgrounds/history_bg_2014.png": 2777,
	"./backgrounds/history_bg_2014.webp": 1955,
	"./backgrounds/history_bg_2017.png": 6770,
	"./backgrounds/history_bg_2017.webp": 1281,
	"./backgrounds/history_bg_2018.png": 5386,
	"./backgrounds/history_bg_2018.webp": 3560,
	"./backgrounds/history_bg_2019.jpg": 5522,
	"./backgrounds/history_bg_2019.webp": 2730,
	"./events/fastio1l.png": 7549,
	"./events/fastio1l.webp": 5909,
	"./events/fastio2_5l.png": 8753,
	"./events/fastio2_5l.webp": 2061,
	"./events/fastio6l.png": 6552,
	"./events/fastio6l.webp": 9162,
	"./events/fastio_newsletters.png": 2569,
	"./events/fastio_newsletters.webp": 8421,
	"./events/fastioglass0_25.png": 7124,
	"./events/fastioglass0_25.webp": 5636,
	"./events/fastiogo0_5l.png": 5073,
	"./events/fastiogo0_5l.webp": 1647,
	"./events/fastiokids0_5l.png": 5487,
	"./events/fastiokids0_5l.webp": 3433
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 780;